export default ({ app }, inject) => {
  inject('rbac', {
    getAccess(path = '') {
      if (app.$session.user.profile === 'PRO' && !app.$session.user.subprofile) return true
      if (app.$session.user.profile === 'MICRO' && !app.$session.user.subprofile) return true

      const roles = app.store.state.admin.roleStore.list

      const checkRoles = app.$session?.user?.roles?.filter(role => role.check) || []

      const hasRole = roles.reduce(
        (acc, role) =>
          checkRoles.some(r => role._id === r._id)
            ? (acc = role.events.reduce(
                (y, event) => (event.group.some(group => group.check && group.path.toUpperCase() === path.toUpperCase()) ? (y = true) : y),
                acc
              ))
            : acc,
        false
      )

      return hasRole
    }
  })
}
